// This file was auto-generated by Fern from our API Definition.
export const QueryEnvironmentRevisionsRequestOrder = {
    Ascending: "ascending",
    Descending: "descending",
};
